@if (this.loadingService.loading$ | async) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
    <span class="spinner-text mt-4">
      <div class="spinner-grow" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </span>
  </div>
}
